import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'sonner';
import { api } from '@/lib/api';
import { Envelope, ArrowRight, ArrowLeft, CheckCircle } from '@phosphor-icons/react';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email) { toast.error('enter your email'); return; }
    setBusy(true);
    try {
      await api.post('/auth/forgot', { email: email.trim().toLowerCase() });
      setSent(true);
    } catch (err) {
      toast.error(err?.response?.data?.detail || 'try again');
    } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen grid place-items-center px-4 py-10">
      <div className="w-full max-w-md">
        <Link to="/login" data-testid="forgot-back" className="inline-flex items-center gap-1.5 text-xs text-white/65 hover:text-white mb-4">
          <ArrowLeft size={14} weight="bold" /> Back to sign in
        </Link>
        <div className="grad-border p-8">
          {sent ? (
            <div className="text-center" data-testid="forgot-success">
              <CheckCircle size={36} weight="duotone" className="text-bx-volt mx-auto" />
              <h1 className="font-display text-3xl font-black tracking-tighter mt-3">Check your inbox.</h1>
              <p className="text-white/65 mt-3 text-sm">
                If <b className="text-bx-cyan">{email}</b> is on file, a reset link is on its way. It's good for one hour.
              </p>
              <p className="text-white/60 mt-4 text-xs">Didn't see it? Check spam, or wait a minute and try again.</p>
              <Link to="/login" className="mt-7 inline-flex btn-primary px-6 py-3 rounded-full text-sm font-bold">
                Back to sign in
              </Link>
            </div>
          ) : (
            <>
              <h1 className="font-display text-3xl font-black tracking-tighter">Forgot password</h1>
              <p className="text-white/55 mt-1 text-sm">Tell us your email and we'll send you a one-hour reset link.</p>
              <form onSubmit={submit} className="mt-6 space-y-4">
                <label className="block">
                  <span className="text-xs uppercase tracking-widest text-white/65">Email</span>
                  <div className="mt-1 flex items-center gap-2 px-3 rounded-xl bg-white/5 border border-white/10 focus-within:border-bx-cyan transition">
                    <Envelope size={16} className="text-white/60" />
                    <input
                      data-testid="forgot-email" type="email" required value={email}
                      onChange={(e) => setEmail(e.target.value)} autoFocus
                      autoComplete="email" placeholder="you@bubblex.app"
                      className="bg-transparent flex-1 py-3 outline-none text-sm" />
                  </div>
                </label>
                <button data-testid="forgot-submit" disabled={busy}
                        className="w-full btn-primary py-3.5 rounded-full text-sm flex items-center justify-center gap-2 disabled:opacity-50">
                  {busy ? 'Sending…' : <>Send reset link <ArrowRight size={16} weight="bold" /></>}
                </button>
              </form>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
